import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { ref, reactive, onMounted, toRefs } from "vue";
import { getCurrentInstance } from "vue";
import apis from "@/api";
import AccountAdd from "./components/AccountAdd";
import UserRoles from "./components/UserRoles";
import ManagerAssign from "./components/ManagerAssign";
const reg_fgs = new RegExp("分公司", "g"); //创建正则RegExp对象

export default {
  components: {
    ManagerAssign,
    UserRoles,
    AccountAdd
  },
  name: "AccountSetting",
  setup() {
    const {
      proxy
    } = getCurrentInstance();
    const userRef = ref(null);
    const roleRef = ref(null);
    const managerRef = ref(null);
    const data = reactive({
      cities: [],
      userInfo: {},
      dialogTitle: "",
      roleDialogVisible: false,
      userDialogVisible: false,
      managerVisible: false,
      queryParam: {
        empName: "",
        userType: "",
        mobile: "",
        status: "1",
        limitName: ""
      },
      pageNo: 1,
      pageSize: 10,
      tableData: [],
      allData: [],
      columns: [{
        label: "账号",
        prop: "userId",
        width: "10%"
      }, {
        label: "姓名",
        prop: "empName",
        width: "12%"
      },
      // {
      //   label: "用户类型",
      //   prop: "userType",
      //   width: "8%",
      //   formatter: (val) => {
      //     if (val === "0") {
      //       return "内部";
      //     } else if (val === "1") {
      //       return "外部";
      //     } else if (val === "2") {
      //       return "第三方";
      //     } else {
      //       return "未知";
      //     }
      //   },
      // },
      // {
      //   label: "性别",
      //   prop: "gender",
      //   width: "5%",
      //   formatter: (val) => {
      //     if (val === "1") {
      //       return "男";
      //     } else if (val === "2") {
      //       return "女";
      //     } else {
      //       return "未知";
      //     }
      //   },
      // },
      {
        label: "手机",
        prop: "mobile",
        width: "11%"
      }, {
        label: "邮箱",
        prop: "email",
        width: "20%",
        overflow: true
      },
      // {
      //   label: "组织名称",
      //   prop: "orgName",
      //   width: "10%",
      //   overflow: true,
      // },
      {
        label: "组织结构",
        prop: "limitName",
        width: "30%",
        formatter: val => {
          if (val) {
            let s = val.replace('组织机构/', '');
            return s.replace(reg_fgs, '');
          }
        }
      }, {
        label: "状态",
        prop: "status",
        width: "5%",
        formatter: val => {
          if (val === "1") {
            return "正常";
          } else if (val === "0") {
            return "冻结";
          } else if (val === "-1") {
            return "初始化";
          } else {
            return "未知";
          }
        }
      }],
      total: 0,
      currentPage: 1,
      searchFlag: false
    });
    const loadData = () => {
      apis.getAccountList({
        pageNo: data.pageNo,
        pageSize: data.pageSize,
        status: data.queryParam.status
      }).then(res => {
        if (res.success) {
          console.log("res:", res);
          data.total = res.data.total;
          data.tableData = res.data.records;
        }
      });
    };
    const resetForm = form => {
      proxy.$refs[form].resetFields();
    };
    const submitForm = form => {
      proxy.$refs[form].validate(valid => {
        if (valid) {
          data.searchFlag = true;
          apis.getAccountList({
            pageNo: data.currentPage,
            pageSize: data.pageSize,
            empName: data.queryParam.empName,
            userType: data.queryParam.userType,
            mobile: data.queryParam.mobile,
            status: data.queryParam.status,
            limitName: data.queryParam.limitName
          }).then(res => {
            data.total = res.data.total;
            data.tableData = res.data.records;
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };
    const sizeChange = pageSize => {
      this.pageSize = pageSize;
      this.currentChange(this.currentPage);
    };
    const currentChange = currentPage => {
      console.log("currentPage:", currentPage);
      if (data.searchFlag) {
        apis.getAccountList({
          pageNo: currentPage,
          pageSize: data.pageSize,
          empName: data.queryParam.empName,
          userType: data.queryParam.userType,
          mobile: data.queryParam.mobile,
          status: data.queryParam.status,
          limitName: data.queryParam.limitName
        }).then(res => {
          console.log("current:records->", res);
          data.total = res.data.total;
          data.tableData = res.data.records;
        });
      } else {
        apis.getAccountList({
          pageNo: currentPage,
          pageSize: data.pageSize,
          status: data.queryParam.status
        }).then(res => {
          console.log("current:records->", res);
          data.total = res.data.total;
          data.tableData = res.data.records;
        });
      }
    };
    const handleUser = row => {
      if (row.id) {
        data.userInfo = row;
        data.dialogTitle = "用户修改";
      } else {
        data.userInfo = {
          userType: "2",
          status: "1"
        };
        data.dialogTitle = "用户新增";
      }
      userRef.value.setUserInfo(data.userInfo);
      userRef.value.setCities(data.cities);
      data.userDialogVisible = true;
    };
    const updateUserStatus = (userInfo, status) => {
      userInfo.status = status;
      apis.editUser(userInfo).then(res => {
        if (res.success) {
          ElMessage.success("账号状态修改成功");
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const showRolesDialog = userInfo => {
      roleRef.value.initUserRoles(userInfo);
      data.roleDialogVisible = true;
    };
    const showManagerDialog = userInfo => {
      managerRef.value.initUserManager(userInfo);
      data.managerVisible = true;
    };
    onMounted(() => {
      loadData();
      console.log("初始化查询开始------------");
      apis.queryAreaList().then(res => {
        if (res.success) {
          data.cities = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
    });
    return {
      ...toRefs(data),
      proxy,
      userRef,
      roleRef,
      managerRef,
      loadData,
      resetForm,
      submitForm,
      currentChange,
      sizeChange,
      handleUser,
      updateUserStatus,
      showRolesDialog,
      showManagerDialog
    };
  }
};